import * as classnames from 'classnames';
import * as React from 'react';
import { useFilterContext } from '../../FilterContext';
import { IFilterItem } from '../../IFilterItem';

interface IProps {
  focusIndex: number;
  index: number;
  item: IFilterItem;
  isSelected: boolean;
  setFocusIndex(number: number): void;
}

export function FilterItem({ focusIndex, index, item, isSelected, setFocusIndex }: IProps) {
  const { handleItemSelect } = useFilterContext();

  const labelClasses = classnames(
    'filter__dropdown-item-label',
    { 'filter__dropdown-item-label--active': isSelected },
    { 'filter__dropdown-item-label--hover': index === focusIndex },
  );

  function handleMouseHover() {
    setFocusIndex(index);
  }

  function handleClick() {
    handleItemSelect(item.value);
  }

  return (
    <div className="filter__dropdown-item" onClick={handleClick} aria-selected={isSelected}>
      <input className="filter__dropdown-item-checkbox" type="checkbox" checked={isSelected} readOnly={true} />
      <label className={labelClasses} onMouseEnter={handleMouseHover}>
        {item.label}
      </label>
    </div>
  );
}
